/*
 * While a form is being sent, its submit button shows a spinner and further submits are ignored,
 * so a double click cannot send it twice. A form that keeps the page, such as a download, opts out
 * with data-busy-state="none".
 */
const BUSY_BUTTON = 'data-busy';
const SUBMITTING_FORM = 'data-submitting';
const SUBMIT_BUTTONS = 'button[type="submit"], button:not([type])';
function hasBusyState(form) {
    return 'none' !== form.dataset['busyState'] && '_blank' !== form.target;
}
export function markBusy(form, submitter) {
    form.setAttribute(SUBMITTING_FORM, '');
    form.setAttribute('aria-busy', 'true');
    const button = submitter ?? form.querySelector(SUBMIT_BUTTONS);
    if (null === button) {
        return;
    }
    // The label turns transparent, so the spinner takes over its colour
    button.style.setProperty('--busy-color', getComputedStyle(button).color);
    button.setAttribute(BUSY_BUTTON, '');
    button.setAttribute('aria-disabled', 'true');
}
export function clearBusy(form) {
    form.removeAttribute(SUBMITTING_FORM);
    form.removeAttribute('aria-busy');
    form.querySelectorAll(`[${BUSY_BUTTON}]`).forEach((button) => {
        button.removeAttribute(BUSY_BUTTON);
        button.removeAttribute('aria-disabled');
    });
}
export default function initFormBusyState() {
    // Bubbling phase: Turbo and confirmation dialogs cancel a submit before this listener runs
    document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || false === hasBusyState(form)) {
            return;
        }
        if (form.hasAttribute(SUBMITTING_FORM)) {
            event.preventDefault();
            return;
        }
        if (false === event.defaultPrevented) {
            markBusy(form, event.submitter);
        }
    });
    // Turbo sends its forms itself and says when it is done
    document.addEventListener('turbo:submit-start', (event) => {
        const { formElement, submitter } = event.detail.formSubmission;
        if (hasBusyState(formElement)) {
            markBusy(formElement, submitter);
        }
    });
    document.addEventListener('turbo:submit-end', (event) => {
        const { formElement } = event.detail.formSubmission;
        clearBusy(formElement);
    });
    // Back restores the page from the back/forward cache with the form still marked as sending
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            document.querySelectorAll(`form[${SUBMITTING_FORM}]`).forEach(clearBusy);
        }
    });
}
